import './App.css'
import { Route, Routes } from "react-router-dom";
import Inicio from "./Componentes/Inicio";
import Carrito from "./Componentes/Carrito";
import FormDirection from './Componentes/FormDirection';
import VerificacionCheckout from './Componentes/VerificacionCheckout';
import Producto from './Componentes/Producto';
import Inventario from './Componentes/Inventario';
import PagarAhora from './Componentes/PagarAhora';
import ProtectedRoute from './services/ProtectedRoute';

function App() {

  let user = 'nN3dLitYhSf3aNrYgdyUmFW4NyB3';
  let user2 = 'AIcjwiF0osaxVD7F3p3eY5cTOg72';
  
  return (
    <Routes>
      <Route path="/" exact element={<Inicio/>}/>
      <Route path="/micarrito" element={<Carrito />}/>
      <Route path="/midireccion" element={<FormDirection />}/>
      <Route path="/payment" element={<VerificacionCheckout />}/>
      <Route path="/product" element={<Producto />}>
        <Route path=":id" element={<Producto />} />
      </Route>
      <Route path="/inventario" element={
        <ProtectedRoute user={user} user2={user2}>
          <Inventario/>
        </ProtectedRoute>
      }/>
      <Route path="/pagar" element={<PagarAhora />}/>
    </Routes>
  );
}

export default App;
